<template>
  <div class="wrapper">
    <nav ref="navRef" class="sidebar side-menu">
      <div class="logo d-flex justify-content-center">
        <img alt="asu logo" class="h-100" :src="getImage('asuLogo.svg')" width="75px" />
      </div>

      <div class="nav-AU">
        <ul class="list-unstyled menu-elements font-12">
          <navigationList
            v-if="$store.state.role == 'student'"
            :navList="navList"
            type="menu"
            @hide="hide"
          />
          <navigationList
            v-else-if="$store.state.role == 'pod operator'"
            :navList="navListpod"
            type="menu"
            @hide="hide"
          />
          <navigationList
            v-else-if="$store.state.role == 'instructor'"
            :navList="navListInstructor"
            type="menu"
            @hide="hide"
          />
          <navigationList
            v-else-if="$store.state.role == 'admin'"
            :navList="navListAdmin"
            type="menu"
            @hide="hide"
          />
        </ul>
      </div>
      <a
        id="side-btn"
        v-dataanchor
        class="btn btn-primary btn-customized side-menu-button open-menu align-items-center justify-content-center p-2"
        :class="
          ($store.state.profile.first_name && $store.state.waivers.length > 0) ||
          ($store.state.profile.role && $store.state.profile.role != 'student')
            ? 'd-flex'
            : 'd-none'
        "
        tagAction="open/close"
        href="#"
        tagEvent="collapse"
        role="button"
        tagSection="sidebar"
        tagText="menu"
        tagType="click"
      >
        <img alt="bars-solid" height="10px" :src="getIcon('bars-solid.svg')" />
        <span class="pl-2 font14 fontRoboto font-weight-bold text-white">MENU</span>
      </a>
    </nav>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useClickOutside } from '@/composables/useClickOutside';
import navigationList from './navList.vue';
import {
  dataLayerAnchorTag,
  dataLayerButtonTag,
  dataLayerSelectTag,
  dataLayerInputTag,
} from 'data-layer-test-oo-gtm';

export default {
  name: 'app',
  components: {
    navigationList,
  },
  directives: {
    dataanchor: dataLayerAnchorTag,
    databutton: dataLayerButtonTag,
    'data-select': dataLayerSelectTag,
    'data-input': dataLayerInputTag,
  },
  setup() {
    const navRef = ref(null);

    const hide = () => {
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.classList.remove('active');
      }
    };

    useClickOutside(navRef, hide);

    return {
      navRef,
    };
  },
  data() {
    return {
      navListpod: [
        {
          name: 'Pod Schedule',
          link: 'portal/pod-schedule',
          icon: 'home-solid.svg',
          type: 'route',
        },
      ],
      navListInstructor: [
        {
          name: 'Pod Schedule',
          link: 'portal',
          icon: 'clock-regular.svg',
          type: 'route',
        },
        {
          name: 'Dashboard',
          link: 'portal',
          icon: 'home-solid.svg',
          type: 'route',
        },
      ],
      navListAdmin: [
        {
          name: 'Scheduler',
          link: 'portal',
          icon: 'calendar-alt-solid.svg',
          type: 'route',
        },
        {
          name: 'Dashboard',
          link: 'portal',
          icon: 'home-solid.svg',
          type: 'route',
        },
        {
          name: 'Pod Schedule',
          link: 'portal',
          icon: 'clock-regular.svg',
          type: 'route',
        },
      ],
    };
  },
  mounted() {
    // Dismiss and overlay click handlers
    document.querySelectorAll('.dismiss, .overlay').forEach((el) => {
      el.addEventListener('click', () => {
        const sidebar = document.querySelector('.sidebar');
        const overlay = document.querySelector('.overlay');
        if (sidebar) sidebar.classList.remove('active');
        if (overlay) overlay.classList.remove('active');
      });
    });

    // Open menu handler
    const openMenuEl = document.querySelector('.open-menu');
    if (openMenuEl) {
      openMenuEl.addEventListener('click', (e) => {
        e.preventDefault();
        const sidebar = document.querySelector('.sidebar');
        const overlay = document.querySelector('.overlay');
        if (sidebar) sidebar.classList.toggle('active');
        if (overlay) overlay.classList.toggle('active');

        const expandedLinks = document.querySelectorAll('a[aria-expanded="true"]');
        expandedLinks.forEach((link) => link.setAttribute('aria-expanded', 'false'));
      });
    }

    // Scroll link handlers
    document.querySelectorAll('a.scroll-link').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        scroll_to(link, 0);
      });
    });

    function scroll_to(clicked_link, nav_height) {
      const element_class = clicked_link.className.split(' ')[0];
      let scroll_to = 0;
      if (element_class !== '.top-content') {
        const targetElement = document.querySelector(element_class + '-container');
        if (targetElement) {
          scroll_to = targetElement.offsetTop - nav_height;
        }
      }
      if (window.scrollY !== scroll_to) {
        window.scrollTo({ top: scroll_to, behavior: 'smooth' });
      }
    }

    // To-top link handler
    const toTopLink = document.querySelector('.to-top a');
    if (toTopLink) {
      toTopLink.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.scrollY !== 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    // Dark theme handler
    const darkBtn = document.querySelector('a.btn-customized-dark');
    if (darkBtn) {
      darkBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const sidebar = document.querySelector('.sidebar');
        if (sidebar) sidebar.classList.remove('light');
      });
    }

    // Light theme handler
    const lightBtn = document.querySelector('a.btn-customized-light');
    if (lightBtn) {
      lightBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const sidebar = document.querySelector('.sidebar');
        if (sidebar) sidebar.classList.add('light');
      });
    }
  },
  methods: {
    checkLogin() {
      if (!this.$store.state.profile.first_name) {
        return 'd-none';
      }
    },
    getImage(img) {
      return require('@/assets/images/' + img);
    },
    getIcon(img) {
      return require('@/assets/icons/' + img);
    },
  },
};
</script>
<style>
.bottom {
  bottom: 0%;
}
.nav-AU {
  display: flex;
  min-height: 80vh;
  flex-direction: column;
  justify-content: center;
}
.howToUsePortal {
  max-width: 150px;
  bottom: 24px;
}
.side-menu {
  background-color: #000000 !important;
  border-right: 1px solid #ffc627;
}
.side-menu-button {
  background-color: #000000 !important;
}
#side-btn:hover {
  background-color: #000000 !important;
  outline: none !important;
  box-shadow: none !important;
}
#side-btn:focus {
  background-color: #000000 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
